'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _project = require('../molecules/project.vue');

var _project2 = _interopRequireDefault(_project);

var _projectAll = require('../molecules/project--all.vue');

var _projectAll2 = _interopRequireDefault(_projectAll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            projectLimit: 5,
            showMore: true
        };
    },

    methods: {
        removeLimit: function removeLimit() {
            this.showMore = false;
            this.projectLimit = this.projects.length;
        }
    },
    components: {
        'project-component': _project2.default,
        'project-all': _projectAll2.default
    },
    props: ['projects', 'readAll']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<ul class=\"project-list\">\n   <li v-for=\"project of projects | limitBy projectLimit\" class=\"project-list__item\">\n        <project-component :project=\"project\">\n        </project-component>\n   </li>\n    <li @click=\"removeLimit\" class=\"project-list__item\" v-show=\"showMore\">\n        <project-all :read-all=\"readAll\">\n        </project-all>\n    </li>\n</ul>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7e2c023d", module.exports)
  } else {
    hotAPI.update("_v-7e2c023d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}